// FIXME: we use de-DE meta-data we didn't have de_CH meta-data yet

export const de_CH_NavRoutes = {
    home: '',
    connection: 'einloggen',
    storesAndServices: 'Storefinder',
    wishlist: 'wunschliste',
    basket: 'warenkorb',
    payment: 'on/demandware.store/Sites-Sephora_DE-Site/de_CH/Cart-GoToPayment',
    account: 'mein-konto',
    orders: 'meine-bestellungen',
    followOrder: 'meine-bestellungen',
    loyalty: 'Sephora-Unlimited.html',
    offers: '',
    profile: 'meine-persoenlichen-informationen',
    mail: '',
    help: 'faq-sephora',
    allServices: 'sephora-store-services.html',
    storeInfo: 'store-information',
    allStores: 'Storefinder',
    countries: 'international.html',
    beautyTips: '',
    logout: 'ausloggen?redirectToReferer=true',
    loyaltyProgram: '',
    allBrands: 'marken/alle-marken-von-a---z-brands',
    clickAndCollect: 'click-and-collect',
    securePayment: 'https://faq.sephora.s/article/Welche-Zahlungsm%C3%B6glichkeiten-gibt-es',
    returnProduct: 'https://faq.sephora.s/article/Wie-kann-ich-ein-Produkt-zur%C3%BCckgeben',
    privacyPolicy: 'datenschutzerklaerung/donnees-personnelles_DE.html',
    search: 'suche?q=',
    reviewConditions: 'general-conditions-publication-reviews.html',
};
